<template>
  <v-dialog
      v-model="dialog"
      max-width="95%"
      transition="dialog-bottom-transition"
  >

    <v-card>
      <v-toolbar
          dark
          dense
          color="primary"
          elevation="0"
          tile
          class="mass-offers-toolbar"
      >
        <v-btn
            icon
            dark
            @click="dialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Bulk Actions - Offers</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <div class="mass-offers">
        <div class="col col-4">
          <span>Advertiser</span>
<!--          :reduce="advertiser => advertiser.advertiser_id"-->
          <custom-select :options="getAdvertisers" label="advertiser"
                         v-model="advertiser"
                         class="custom_select" :clearable="false">
          </custom-select>
          <v-progress-circular
              class="custom_select_circular"
              v-if="getAdvertisers.length == 0 ? true : false"
              indeterminate
              color="primary"
              size="20"
          ></v-progress-circular>
        </div>

        <v-subheader>Upload offers from CSV file.</v-subheader>

        <v-container
            class="px-0"
            fluid
        >
          <div class="text-left">
            <v-btn
                depressed
                :color="isUpdate ? '' : 'primary'"
                @click="isUpdate = !isUpdate; fileContent = []"
            >
              ADD
            </v-btn>

            <v-btn
                depressed
                :color="isUpdate ? 'primary' : ''"
                @click="isUpdate = !isUpdate; fileContent = []"
            >
              UPDATE
            </v-btn>
          </div>
          <label> choose template of CSV file for {{isUpdate ? 'Update' : 'add'}} offers    </label>
        </v-container>

        <v-row>
          <v-col cols="4">
            <v-file-input
                accept=".csv"
                :label="isUpdate
              ? 'Click here to select a .csv update file'
              : 'Click here to select a .csv for add file '"
                outlined
                v-model="chosenFile"
                class="mass-offer-input"
            >
            </v-file-input>
          </v-col>
          <v-col cols="8">
            <v-btn
                elevation="0"
                color="primary"
                x-large
                @click="importCsv">
              <i class="fal fa-file-import mr-2"></i>
              Import file
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
          </v-col>
          <v-col cols="8" style="margin-top: -40px;">
            <a :href="isUpdate ? '../../batch_offer_update_sample_program.csv':'../../batch_offer_add_sample_program.csv'">
              Download CSV Template ({{isUpdate ? 'update' : 'add'}})
            </a>
          </v-col>
        </v-row>

        <label>
          Count of selected records:
          <span class="count">{{ this.selected.length }}
          </span>
        </label>
        <v-spacer></v-spacer>
        <label>
          Count of all records:
          <span class="count">{{ this.fileContent.length }}
          </span>
        </label>
        <v-spacer></v-spacer>

        <v-data-table
            v-model="selected"
            :headers="isUpdate ? headersUpd : headers"
            :items="this.fileContent"
            show-select
            :item-key="isUpdate ? 'offerId' : 'offerName'"
            :single-select="singleSelect"
            class="elevation-1 offer-upload-grid"
        >

        </v-data-table>
        <div class="loader-wrapper" v-if="loading">
          <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
          ></v-progress-circular>
        </div>

        <v-btn
            elevation="0"
            color="primary"
            @click="isUpdate ? updateOffersDb() : insertOffersDb()" style="margin-right: 10px"
        >
          {{ isUpdate ? 'Update Selected Offers' : 'Add Selected Offers' }}
        </v-btn>
        <v-btn
            elevation="0"
            color="primary"
            @click="isUpdate ? updateOffersDb(true) : insertOffersDb(true)"
            style="margin-right: 10px"
        >
          {{ isUpdate ? 'Update All Offers' : 'Add All Offers' }}
        </v-btn>

        <v-btn elevation="0" color="primary" @click="dialog = false">Close</v-btn>

        <ul id="successAdded">
          <h2>
            Success Added Count <span class="successAdded">{{ this.addedOffers.length }}</span>
          </h2>
          {{this.addedOffers.length !== 0 && JSON.stringify(this.addedOffers.map(i=>i.name)) || ''}}

        </ul>

        <ul id="failedAdded">
          <h2>Failed Count <span class="failedAdded">{{ this.failedOffers.length }}</span></h2>
        </ul>
        {{this.failedOffers.length !== 0 &&
      JSON.stringify(this.failedOffers.map(i=>i.error)) || '' }}
        <ul id="existsOffer">
          <h2>
            {{this.isUpdate ? 'Offers does not exists in DB' : 'Offers  already exists in DB '}}
            <span class="failedAdded">{{ this.existsOffer.length }}</span>
          </h2>
          {{this.existsOffer.length !== 0 && JSON.stringify(this.existsOffer.map(i=>i.name)) || ''}}

        </ul>

        <ul id="validation">
          <h2>
            validation  <span class="failedAdded">{{ this.validation.length }}</span>
          </h2>
          <!--          {{this.validation.length !== 0 && JSON.stringify(this.validation.map(i=>i)) || ''}}-->
          <thead v-if="this.validation.length !==0">
          <tr>
            <th
                class="text-left"
                style="width: 400px;"
            >
              offerName
            </th>
            <th class="text-left">
              validation error
            </th>
            <th style="width: 50px;"></th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(item, index) in this.validation"
              :key="index"
          >
            <td>
              {{item.offerName}}
            </td>
            <td>
              <div v-if="item.wrongValidation.length !==0">
                <div v-for="([validation],ind) in item.wrongValidation" :key="ind">
                  {{validation.key }} - {{validation.value }}
                </div>
              </div>

            </td>
          </tr>
          </tbody>
        </ul>
      </div>
    </v-card>

  </v-dialog>
</template>

<script>
import csvParse from 'csv-parse';
import {mapGetters, mapState} from "vuex";
import store from "@/store";
import offerApi from "@/api/offer";
import { getAllISOCodes } from 'iso-country-currency';
import {getCookie} from "@/helpers";

export default {
  name: 'MassOffersUpload',
  components: {},
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: 'open',
    event: 'toggle',
  },
  async mounted() {
    this.dialog = this.open;
    await store.dispatch('verticals/saveVerticalsStore')
    await store.dispatch('offers/saveOfferCurrenciesStore')
    await store.dispatch('currencies/saveCurrencyStore')
    await store.dispatch('offers/saveAdvertisersStore', {token: getCookie('accessToken')})
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('offers', [
      'getOfferCurrencies', 'getAdvertisers'
    ]),
    ...mapGetters('verticals', ['getVerticals']),
    ...mapGetters('currencies', ['getCurrencies']),
  },
  methods: {
    nullVariable() {
      this.loading = true;
      this.existsOffer = [];
      this.addedOffers = [];
      this.validation = [];
    },
    geoRulesFormat(geo) {
      const geoRules = {};
      geoRules.geo = geo;
      return JSON.stringify(geoRules);
    },
    async alert() {
      await this.$dialog.info({
        text: `No records selected`,
        title: 'Validation Error'
      })
      this.loading = false;
    },
    async updateOffersDb(all) {
      if (!this.advertiser.advertiser_id){
        await this.$dialog.error({
          text: 'Choose advertiser',
          title: 'Advertiser is empty'
        })
        return
      }
      try {
        this.nullVariable();
        const listOfRecordsToUpdate = all ? this.fileContent : this.selected;
        if (listOfRecordsToUpdate.length === 0) {
           await this.alert();
          return;
        }
        for (const offerCSV of listOfRecordsToUpdate) {
          const offerUpdate = await store.dispatch('offer/getOfferById', offerCSV.offerId)
          const offerCapDb = await store.dispatch('offer/getOfferCapsById', offerCSV.offerId)
          const landingsDb = await store.dispatch('lpOffers/getLp', offerCSV.offerId)
          if (offerUpdate) {
            const offerNameDb = offerUpdate.name;
            const conversionTypeDb = offerUpdate.conversionType;
            const verticalIdDb = offerUpdate.verticalId;
            const verticalNameDb = offerUpdate.verticalName;
            const offerIdRedirectDb = offerUpdate.offerIdRedirect;
            const currencyIdDb = offerUpdate.currencyId;
            const descriptionDb = offerUpdate.descriptions;
            const payInDb = offerUpdate.payIn;
            const payOutDb = offerUpdate.payOut;
            const isCpmOptionEnabledDb = offerUpdate.isCpmOptionEnabled;
            const useStartEndDateDb = offerUpdate.useStartEndDate;
            const geoRulesDb = offerUpdate.geoRules;
            const statusDb = offerUpdate.status;
            const advertiserIdDb = offerUpdate.advertiserId;
            const advertiserNameDb = offerUpdate.advertiserName;

            const landingsFormat = landingsDb ? landingsDb.map((lp) => ({
              name: lp.name,
              id: lp.id,
              url: lp.url,
            })) : [];

            let geoRulesCsv;
            if (offerCSV.blockedGEO) {
              const blockedGEOArr = offerCSV.blockedGEO.split(',');
              const geoFormat = [];
              const validateData = [];
              const countryCodes = this.countryList.map((i) => i.iso).join(',');
              const countryWrong = [];
              blockedGEOArr.forEach((countryCode) => {
                if (countryCodes.includes(countryCode)) {
                  geoFormat.push({ country: countryCode, include: true });
                } else {
                  countryWrong.push(countryCode);
                }
              });
              if (countryWrong.length !== 0) {
                const geo = [{ key: 'geo', value: countryWrong.join(',') }];
                validateData.push(geo);
              }

              geoRulesCsv = this.geoRulesFormat(geoFormat);
            }

            const customPayInCsv = [];
            if (offerCSV.customPayin) {
              const customPayinFormat = offerCSV.customPayin.split(',');
              // eslint-disable-next-line array-callback-return
              customPayinFormat.map((i) => {
                const tmp = i.split(':');
                if (tmp[0] && tmp[1]) {
                  customPayInCsv.push({
                    id: null,
                    geo: tmp[0],
                    payIn: parseFloat(tmp[1].toString()),
                    payOut: 0,
                  });
                }
              });
            }
            // this.$toast.success(`Offer id ${offer.offerId} exists in DB `);
            const keys = Object.keys(offerCSV);
            const fields = [];
            keys.forEach((key) => {
              if (Number(offerCSV[key]) !== 0 || offerCSV[key] === '0') {
                fields.push(key);
              }
            });
            const update = {};
            fields.forEach((f) => {
              update[f] = offerCSV[f];
            });
            const validateData = [];
            if (offerCSV.landingPageUrl) {
              const prefix = 'http';

              if (offerCSV.landingPageUrl.substr(0, prefix.length) !== prefix) {
                offerCSV.landingPageUrl = `${prefix}://${offerCSV.landingPageUrl}`;
              }

              const validateResp = this.validationCsv('landingPageUrl', offerCSV.landingPageUrl);
              if (validateResp && validateResp.length !== 0) {
                validateData.push(validateResp);
              }
            }
            if (advertiserIdDb !== this.advertiser.advertiser_id){
              const adv =[{key:'advertiser', value:`Wrong Advertiser`}]
              console.log(`Expect advertiser ${ advertiserNameDb}`)
              validateData.push(adv);
            }
            if (validateData.length !== 0) {
              this.validation.push({
                offerName: offerCSV.offerName,
                wrongValidation: validateData,
              });
              // eslint-disable-next-line no-continue
              continue;
            }

            let landingsCsv;
            if (offerCSV.landingPageUrl) {
              landingsCsv = [{
                id: 0,
                name: 'default',
                url: offerCSV.landingPageUrl,
                isDefault: true,
              }];
            }
            const offerStatusCsv = offerCSV.status;
            const offerStatusDB = statusDb;
            let offerStatusToUpdate = 'inactive';
            if (offerStatusCsv === 'active') {
              if (offerStatusDB === 'private'
                  || offerStatusDB === 'public'
                  || offerStatusDB === 'pending'
              ) {
                offerStatusToUpdate = offerStatusDB;
              }
            }
            if (offerStatusDB === 'inactive' && offerStatusCsv === 'active') {
              offerStatusToUpdate = 'pending';
            }
            const data = {
              id: offerCSV.offerId,
              name: update.offerName ? offerCSV.offerName : offerNameDb,
              conversionType: offerCSV.conversionType ? offerCSV.conversionType.toLowerCase() : conversionTypeDb,
              currencyId: offerCSV.currency ? offerCSV.currency : currencyIdDb,
              defaultLp: offerCSV.landingPageUrl ? 0 : landingsDb[0].id,
              defaultSiteName: offerCSV.landingPageUrl ?  offerCSV.landingPageUrl : landingsDb[0].url ,
              descriptions: offerCSV.description ?  offerCSV.description : descriptionDb ,
              startDate: '',
              endDate: '',
              isRestricted: false,
              marginType: 'fixed',
              status: offerStatusCsv ? offerStatusToUpdate : offerStatusDB,
              payIn: offerCSV.payIn ? offerCSV.payIn.toString() : payInDb,
              programId: Number(offerCSV.programId),
              payOut: payOutDb,
              advertiserId: this.advertiser.advertiser_id,
              advertiserName: this.advertiser.advertiser,
              advertiserManagerId: 38,
              restrictions: '',
              verticalId: verticalIdDb,
              verticalName: verticalNameDb,
              geoRules: offerCSV.blockedGEO ? geoRulesCsv : geoRulesDb,
              useStartEndDate: 0,
              lp: offerCSV.landingPageUrl ? landingsCsv : landingsFormat,
              offerIdRedirect: 0,
              isCpmOptionEnabled: 0,
              customPayOut: offerCSV.customPayin ? customPayInCsv : 0,
              caps: {
                offerId: offerCSV.offerId,
                clickDay: 0,
                clickWeek: 0,
                clickMonth: 0,
                clicksRedirectStatus: 'default',
                clicksRedirectOfferId: 0,
                clickExitTrafficOfferName: null,
                clicksRedirectOfferUseDefault: 1,
                salesDay: offerCSV.salesDailyCap ? offerCSV.salesDailyCap : offerCapDb.salesDay,
                salesWeek: offerCSV.salesWeekCap ? offerCSV.salesWeekCap : offerCapDb.salesWeek,
                salesMonth: offerCSV.salesMonth ? offerCSV.salesMonth : offerCapDb.salesMonth,
                salesRedirectStatus: 'default',
                salesRedirectOfferId: 0,
                saleExitTrafficOfferName: null,
                salesRedirectOfferUseDefault: 1,
                useStartEndDate: 1,
                startDate: null,
                endDate: null,
                enabled: offerCapDb.enabled
              },
            }

            let res = await offerApi.saveOffer(data)
            if (res.id) {
              await this.$dialog.notify.success(`update offer ${offerCSV.offerName}  `, {
                position: 'top-right',
                timeout: 100
              })
            }
            this.addedOffers.push({
              name: offerCSV.offerId,
            });
          } else {
            this.existsOffer.push({
              name: offerCSV.offerId,
            });
          }
        }
        this.loading = false;
      } catch (e) {
        console.error(e);
        this.loading = false;
        this.failedOffers.push({
          error: e.toString(),
        });
        await this.$dialog.error({
          text: e.toString(),
          title: 'Failed offer'
        })
      }
    },
    async insertOffersDb(all) {
      if (!this.advertiser.advertiser_id){
        await this.$dialog.error({
          text: 'Choose advertiser',
          title: 'Advertiser is empty'
        })
        return
      }

      this.nullVariable();
      try {
        const listOfRecordsToInsert = all ? this.fileContent : this.selected;
        if (listOfRecordsToInsert.length === 0) {
          await this.alert();
          return;
        }
        let count = 0;
        for (const offer of listOfRecordsToInsert) {
          const emptyKey = [];
          const validateData = [];
          const keys = Object.keys(offer);
          const ignoreKeys = ['salesDailyCap', 'salesMonthlyCap', 'salesWeekCap', 'customPayin', 'acceptedGEO', 'blockedGEO'];
          keys.forEach((key) => {
            if (ignoreKeys.includes(key)) {
              return;
            }
            if (Number(offer[key]) === 0) {
              emptyKey.push(key);
            }
            const validateResp = this.validationCsv(key, offer[key]);
            if (validateResp && validateResp.length !== 0) {
              validateData.push(validateResp);
            }
          });
          count++;
          if (emptyKey.length !== 0 || validateData.length !== 0) {
            this.validation.push({
              record: count,
              offerName: offer.offerName,
              emptyKey,
              wrongValidation: validateData,
            });
            continue;
          }

          const customPayin = [];
          if (offer.customPayin) {
            const customPayinFormat = offer.customPayin.split(',');
            // eslint-disable-next-line array-callback-return
            customPayinFormat.map((i) => {
              const tmp = i.split(':');
              if (tmp[0] && tmp[1]) {
                customPayin.push({
                  id: null,
                  geo: tmp[0],
                  payIn: parseFloat(tmp[1].toString()),
                  payOut: 0,
                });
              }
            });
          }

          const { currency, verticalName } = offer;
          const [currencyMatch] = this.getCurrencies.filter((i) => (i.name === currency));

          const [verticalsMatch] = this.getVerticals
              .filter((i) => (i.name.toLowerCase() === verticalName.toLowerCase()));

          // const checkOffer = await store.dispatch('offer/checkOfferNameExists', offer.offerName)
          //
          // if (!!checkOffer.count) {
          //   await this.$dialog.notify.success(`Offer name ${offer.offerName} already exists in DB `, {
          //     position: 'top-right',
          //     timeout: 100
          //   })
          //   this.existsOffer.push({
          //     name: offer.offerName,
          //   });
          //   continue;
          // }

          let createOfferResponse = await store.dispatch('offer/createOffer', {
            name: offer.offerName,
            type: 'regular'
          })

          const offerId = createOfferResponse && createOfferResponse.id || 0;

          const blockedGEOArr = offer.blockedGEO.split(',');
          const geoFormat = [];
          blockedGEOArr.forEach((countryCode) => {
            if (countryCode) {
              geoFormat.push({ country: countryCode, include: true });
            }
          });

          // const acceptedGEOArr = offer.acceptedGEO.split(',');
          // acceptedGEOArr.forEach((countryCode) => {
          //   if (countryCode) {
          //     geoFormat.push({ country: countryCode, include: false });
          //   }
          // });
          const geoRules = this.geoRulesFormat(geoFormat);

          const landings = [{
            id: 0,
            name: 'default',
            url: offer.landingPageUrl,
            isDefault: true,
          }];
          const capsEnabled = (offer.salesDailyCap || offer.salesWeekCap || offer.salesMonthlyCap) ? 1 :0;
          const data = {
            id: offerId,
            name: offer.offerName,
            conversionType: offer.conversionType.toLowerCase(),
            currencyId: currencyMatch.id,
            defaultLp: 0,
            defaultSiteName: offer.landingPageUrl.replace(/\n/g, '').trim(),
            descriptions: offer.description,
            startDate: '',
            endDate: '',
            isRestricted: false,
            marginType: 'fixed',
            status: 'pending',
            payIn: offer.payIn ? parseFloat(offer.payIn.toString()) : 0,
            programId: offer.programId,
            payOut: 0,
            advertiserId: this.advertiser.advertiser_id,
            advertiserName: this.advertiser.advertiser,
            advertiserManagerId: 38,
            restrictions: '',
            verticalId: verticalsMatch.id,
            verticalName: verticalsMatch.name,
            geoRules: geoRules || '{"geo":[]}',
            useStartEndDate: 0,
            lp:landings,
            offerIdRedirect: 0,
            isCpmOptionEnabled: 0,
            customPayOut:customPayin,
            caps: {
              offerId: offerId,
              clickDay: 0,
              clickWeek: 0,
              clickMonth: 0,
              clicksRedirectStatus: 'default',
              clicksRedirectOfferId: 0,
              clickExitTrafficOfferName: null,
              clicksRedirectOfferUseDefault: 1,
              salesDay: offer.salesDailyCap ? parseInt(offer.salesDailyCap.toString(), 10) : 0,
              salesWeek: offer.salesWeekCap ? parseInt(offer.salesWeekCap.toString(), 10) : 0,
              salesMonth: offer.salesMonthlyCap  ? parseInt(offer.salesMonthlyCap.toString(), 10) : 0,
              salesRedirectStatus: 'default',
              salesRedirectOfferId: 0,
              saleExitTrafficOfferName: null,
              salesRedirectOfferUseDefault: 1,
              useStartEndDate: 1,
              startDate: null,
              endDate: null,
              enabled: capsEnabled
            },
          }

          let res = await offerApi.saveOffer(data)
          if (res.id) {
            await this.$dialog.notify.success(`Added offer ${offer.offerName}  `, {
              position: 'top-right',
              timeout: 100
            })
          }
          this.addedOffers.push({
            name: offer.offerName,
          });
        }
        this.loading = false;
      } catch (e) {
        this.failedOffers.push({
          error: e.toString(),
        });
        await this.$dialog.error({
          text: e.toString(),
          title: 'Failed offer'
        })
      }
    },
    async importCsv() {
      try {
        if (!this.chosenFile) {
          await this.$dialog.info({
            text: `No file selected`,
            title: 'Validation Error'
          })
          return;
        }
        this.loading = true;
        const readFile = await this.processFile(this.chosenFile);
        const csvHeaders = readFile.split('\r')[0];
        if (this.isUpdate) {
          // Offer ID is required and at least one other field
          if (
              !csvHeaders.includes('Offer ID')
              || (!csvHeaders.includes('New Landing Page')
                  && !csvHeaders.includes('New Offer Name')
                  && !csvHeaders.includes('New Status')
                  && !csvHeaders.includes('New Daily Caps')
                  && !csvHeaders.includes('New Weekly Caps')
                  && !csvHeaders.includes('New Monthly Caps')
                  && !csvHeaders.includes('New Authorized GEOs')
                  && !csvHeaders.includes('New Blocked GEOs')
                  && !csvHeaders.includes('New Conversion Type')
                  && !csvHeaders.includes('New Currency')
                  && !csvHeaders.includes('New Base Price')
                  && !csvHeaders.includes('New GEO Price'))

          ) {
            await this.$dialog.error({
              text: `Wrong format for update csv, check template`,
              title: 'Validation Error'
            })
            this.loading = false;
            return;
          }
        } else if (
            !csvHeaders.includes('Category')
            || !csvHeaders.includes('Product')
            || !csvHeaders.includes('Landing Page')
            || !csvHeaders.includes('Offer Name')
            || !csvHeaders.includes('Daily Caps')
            || !csvHeaders.includes('Weekly Caps')
            || !csvHeaders.includes('Monthly Caps')
            || !csvHeaders.includes('Blocked GEOs')
            || !csvHeaders.includes('Conversion Type')
            || !csvHeaders.includes('Currency')
            || !csvHeaders.includes('Program ID')
            || !csvHeaders.includes('GEO Price')
        ) {
          await this.$dialog.error({
            text: `Wrong format for create csv, check template`,
            title: 'Validation Error'
          })
          this.loading = false
          return;
        }

        const data = this.isUpdate
            ? await this.formatDataUpdate(readFile)
            : await this.formatData(readFile);

        data.shift();
        this.fileContent = data;
        this.selected = [];
        this.existsOffer = [];
        this.validation = [];
        this.loading = false;
      } catch (e) {
        console.log('importCsvError', e);
        await this.$dialog.error({
          text: `error`,
          title: e.toString()
        })
        this.loading = false
      }
    },
    async formatData(dataFile) {
      const csvHeaders = dataFile.split('\r')[0];
      const csvHeadersArray = csvHeaders.split(',');
      const headersMap = {};
      csvHeadersArray.forEach((i, index) => {
        headersMap[i] = index;
      });
      return new Promise((resolve, reject) => csvParse(
          dataFile,
          {},
          (err, output) => (err ? reject(err) : resolve(output.map((record) => ({
            offerName: record[headersMap['Offer Name']] && record[headersMap['Offer Name']].trim(),
            verticalName: record[headersMap.Category] && record[headersMap.Category].trim(),
            conversionType: record[headersMap['Conversion Type']] && record[headersMap['Conversion Type']].trim(),
            currency: record[headersMap.Currency] && record[headersMap.Currency].trim(),
            blockedGEO: record[headersMap['Blocked GEOs']] && record[headersMap['Blocked GEOs']].trim(),
            landingPageUrl: record[headersMap['Landing Page']] && record[headersMap['Landing Page']].trim(),
            description: record[headersMap.Product] && record[headersMap.Product].trim(),
            salesDailyCap: record[headersMap['Daily Caps']] && record[headersMap['Daily Caps']].trim(),
            salesWeekCap: record[headersMap['Weekly Caps']] && record[headersMap['Weekly Caps']].trim(),
            salesMonthlyCap: record[headersMap['Monthly Caps']] && record[headersMap['Monthly Caps']].trim(),
            programId: record[headersMap['Program ID']] && record[headersMap['Program ID']].trim(),
            customPayin: record[headersMap['GEO Price']] && record[headersMap['GEO Price']].trim(),
          })))),
      ));
    },
    async formatDataUpdate(dataFile) {
      const csvHeaders = dataFile.split('\r')[0];
      const csvHeadersArray = csvHeaders.split(',');
      const headersMap = {};
      csvHeadersArray.forEach((i, index) => {
        headersMap[i] = index;
      });
      return new Promise((resolve, reject) => csvParse(
          dataFile,
          {},
          (err, output) => (err ? reject(err) : resolve(output.map((record) => ({
            offerId: record[headersMap['Offer ID']] && record[headersMap['Offer ID']].trim(),
            offerName: record[headersMap['New Offer Name']] && record[headersMap['New Offer Name']].trim(),
            description: record[headersMap['New Product']] && record[headersMap['New Product']].trim(),
            landingPageUrl: record[headersMap['New Landing Page']] && record[headersMap['New Landing Page']].trim(),
            salesDailyCap: record[headersMap['New Daily Caps']] && record[headersMap['New Daily Caps']].trim(),
            salesWeekCap: record[headersMap['New Weekly Caps']] && record[headersMap['New Weekly Caps']].trim(),
            salesMonthlyCap: record[headersMap['New Monthly Caps']] && record[headersMap['New Monthly Caps']].trim(),
            status: record[headersMap['New Status']] && record[headersMap['New Status']].trim(),
            conversionType: record[headersMap['New Conversion Type']] && record[headersMap['New Conversion Type']].trim(),
            currency: record[headersMap['New Currency']] && record[headersMap['New Currency']].trim(),
            acceptedGEO: record[headersMap['New Authorized GEOs']] && record[headersMap['New Authorized GEOs']].trim(),
            blockedGEO: record[headersMap['New Blocked GEOs']] && record[headersMap['New Blocked GEOs']].trim(),
            // payIn: record[headersMap['New Base Price']] && record[headersMap['New Base Price']].trim(),
            programId: record[headersMap['New Program ID']] && record[headersMap['New Program ID']].trim(),
            customPayin: record[headersMap['New GEO Price']] && record[headersMap['New GEO Price']].trim(),
          })))),
      ));
    },
    async parse(file) {
      const reader = new FileReader();
      reader.readAsText(file);
      return await new Promise((resolve, reject) => {
        reader.onload = () => {
          resolve(reader.result);
        };
      });
    },
    validationCsv(key, value) {
      const validation = [];
      const conversionType = ['cpi', 'cpa', 'cpc'];
      const isValidUrl = (string) => /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/g.test(string);
      switch (key) {
        case 'conversionType': {
          if (!conversionType.includes(value.toLowerCase())) {
            validation.push({ key, value });
          }
          break;
        }
        case 'landingPageUrl': {
          try {
            const domain = new URL(value);
            if (!(isValidUrl(domain.origin))) {
              validation.push({ key, value });
            }
          } catch (e) {
            validation.push({ key, value });
          }

          break;
        }
        case 'verticalName': {
          const [verticalsMatch] = this.getVerticals
              .filter((i) => (i.name.toLowerCase() === value.toLowerCase()));

          if (!verticalsMatch) {
            validation.push({ key, value });
          }
          break;
        }
        case 'currency': {
          const [currencyMatch] = this.getCurrencies
              .filter((i) => (i.name === value));
          if (!currencyMatch) {
            validation.push({ key, value });
          }
          break;
        }
        default:
      }
      return validation;
    },
    async processFile(file) {
      try {
        return await this.parse(file);
      } catch (e) {
        console.log('processFileError:', e);

        await this.$dialog.error({
          text: `error`,
          title: e.toString()
        })
      }
    },
  },
  data() {
    return {
      countryList: getAllISOCodes(),
      currencies: [],
      verticals: [],
      dialog: this.open,
      loading: false,
      chosenFile: null,
      fileContent: [],
      advertiser: {},
      data: null,
      selected: [],
      existsOffer: [],
      validation: [],
      singleSelect: false,
      isUpdate: false,
      radios: false,
      addedOffers: [],
      failedOffers: [],
      headers: [
        {
          text: 'Offer Name',
          align: 'start',
          sortable: false,
          value: 'offerName',
        },
        { text: 'Category', value: 'verticalName' },
        { text: 'Product', value: 'description' },
        { text: 'Landing Page', value: 'landingPageUrl' },
        { text: 'Daily Sales', value: 'salesDailyCap' },
        { text: 'Weekly Sales', value: 'salesWeekCap' },
        // { text: 'Accepted GEO', value: 'acceptedGEO' },
        { text: 'Monthly Sales', value: 'salesMonthlyCap' },
        { text: 'Blocked GEOs', value: 'blockedGEO' },
        { text: 'Conversion Type', value: 'conversionType' },
        { text: 'Currency', value: 'currency' },
        { text: 'Program ID', value: 'programId' },
        { text: 'GEO Price', value: 'customPayin' },
      ],
      headersUpd: [
        {
          text: 'Offer ID',
          align: 'start',
          sortable: false,
          value: 'offerId',
        },
        { text: 'Offer Name', value: 'offerName' },
        { text: 'Product', value: 'description' },
        { text: 'Landing Page', value: 'landingPageUrl' },
        { text: 'Daily Sales', value: 'salesDailyCap' },
        { text: 'Weekly Sales', value: 'salesWeekCap' },
        { text: 'Monthly Sales', value: 'salesMonthlyCap' },
        { text: 'Status', value: 'status' },
        { text: 'Conversion Type', value: 'conversionType' },
        { text: 'Currency', value: 'currency' },
        { text: 'Accepted GEO', value: 'acceptedGEO' },
        { text: 'GEOs to block', value: 'blockedGEO' },
        { text: 'Program ID', value: 'programId' },
        { text: 'GEO Price', value: 'customPayin' },
      ],
    };
  },
  watch: {
    dialog() {
      this.$emit('toggle', this.dialog);
    },
    open() {
      this.dialog = this.open;
    },
  },
};
</script>

<style lang="sass">
.offer-upload-grid
  .v-data-table__wrapper
    height: 40vh
    overflow: auto

.mass-offers-toolbar
  padding: 0px 20px

.mass-offers
  padding: 20px

.v-data-footer
  margin-bottom: 20px

.v-input.mass-offer-input.v-text-field--outlined > .v-input__control > .v-input__slot
  min-height: 52px !important

.v-input.mass-offer-input.v-text-field > .v-input__control > .v-input__slot
  cursor: pointer

span.count
  background-color: transparent !important
  color: var(--v-primary-base) !important
  font-size: inherit
  font-weight: 600

span.successAdded
  background-color: transparent !important
  color: var(--v-success-base) !important
  font-size: inherit

span.failedAdded
  background-color: transparent !important
  color: var(--v-error-base) !important
  font-size: inherit

ul#successAdded li, ul#failedAdded li
  margin-left: 30px
</style>
